import { createTheme } from "@mui/material/styles";

export const LU_RED = "#FF0000";
export const LU_YELLOW = "#fffc00";

const luTheme = createTheme({
  palette: {
    primary: {
      main: LU_RED,
      contrastText: "#ffffff",
    },
    secondary: {
      main: LU_YELLOW,
      contrastText: "#0a0a0a",
    },
    text: {
      primary: "#0a0a0a",
      secondary: "#64748b",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Outfit", Inter, sans-serif',
    h1: { fontWeight: 900, letterSpacing: "-0.02em" },
    h2: { fontWeight: 900 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 800 },
    button: { fontWeight: 700, textTransform: "none" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 700,
        },
        containedPrimary: {
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid rgba(2, 6, 23, 0.1)",
          boxShadow: "0 12px 32px rgba(2, 6, 23, 0.07)",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
        },
      },
    },
  },
});

export default luTheme;
